const MAX_PRINT_PAGES = 2000;
const MAX_WIDTH = 50000000;
const MAX_HEIGHT = 50000000;

// Total Points -> Scale Percentage
const PRVIEWABLE_SCALE_SIZES_MAP = {
  50000000: 100,
  51000000: 80,
  80000000: 50,
  110000000: 30,
  300000000: 10,
  1800000000: 1
};

export { MAX_HEIGHT, MAX_PRINT_PAGES, MAX_WIDTH, PRVIEWABLE_SCALE_SIZES_MAP };
